import { Link } from 'react-router-dom';

const acts = [
  {
    num: '01',
    label: 'Our Roots',
    heading: 'Humble\nBeginnings',
    body: 'Founded in 2006 by dedicated professionals who devoted their careers to molding young minds through quality academic and moral education. Determined and resilient, our founders overcame every obstacle before the school opened its doors.',
  },
  {
    num: '02',
    label: 'Our Mission',
    heading: 'Lead &\nInnovate',
    body: 'To be a leading private educational services provider in Nigeria and beyond — researching and acquiring new skills in foundation education, adapting to provide the same in the most efficient manner possible.',
  },
  {
    num: '03',
    label: 'Our Vision',
    heading: 'Shape Every\nChild',
    body: 'We provide an unparalleled high standard of educational systems that stimulate rapid intellectual growth, instilling confidence and discipline in every child — molding them to interact favourably with their world.',
  },
];

const StorySection = () => (
  <section id="about" className="relative overflow-hidden bg-[#101c32] py-16 sm:py-20 lg:py-24 text-white">
    <div className="container mx-auto px-6">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-10 lg:mb-12">
        <div><p className="text-orange-300 text-xs font-bold tracking-[0.22em] uppercase mb-3">Our Story</p>
          <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">Renaissance Garden Schools</h2>
        </div>
        <Link to="/about" className="inline-flex items-center gap-2 rounded-full border border-white/25 px-5 py-3 text-sm font-semibold text-white hover:bg-white/10">About Us <span aria-hidden>↗</span></Link>
      </div>
      <div className="grid lg:grid-cols-3 gap-8 lg:gap-10">
        {acts.map(act => <article key={act.num} className="border-t border-white/20 pt-6">
          <div className="flex items-center gap-3 mb-5"><span className="text-sm font-semibold text-orange-300">{act.num}</span><p className="text-xs font-semibold tracking-[0.16em] uppercase text-white/75">{act.label}</p></div>
          <h3 className="font-display text-2xl sm:text-3xl font-bold tracking-tight leading-tight mb-4">{act.heading.replace('\n', ' ')}</h3>
          <p className="text-base leading-relaxed text-slate-300">{act.body}</p>
        </article>)}
      </div>
      <p className="mt-10 text-xs text-slate-400 tracking-wide">Renaissance Garden Schools · Since 2006</p>
    </div>
  </section>
);
export default StorySection;
